'use strict';

angular.module('m42AccessControlServiceFrontendApp').service('M42Validation', function () {
    var self = this;

    self.isEmpty = function(val) {
        return typeof(val) === 'undefined' || val === null || val === '';
    };
});
